import CoreTravel from 'core/js/pages/municipality-data/travels/_travel'
import template from './_travel.pug'

export default CoreTravel.extend({
  template: template(),

  computed: {
    originZoneDescription() {
      return this.travel.node_from_name || null
    },

    destinationZoneDescription() {
      return this.travel.node_to_name || null
    },

    traveledKilometers() {
      const value = Number(this.travel.kilometers_traveled)

      if (!value) return null

      return `${value.toFixed(2)} km`
    },

    hasZoneInfo() {
      const t = this.travel || {}

      const hasOrigin =
        typeof t.node_from_name === 'string' &&
        t.node_from_name.trim().length > 0

      const hasDestination =
        typeof t.node_to_name === 'string' &&
        t.node_to_name.trim().length > 0

      const km = Number(t.kilometers_traveled)
      const hasValidKm = Number.isFinite(km) 

      return t.type === 8 && hasOrigin && hasDestination && hasValidKm
    }
  }
})
